import React, { useEffect, useState } from 'react';
import { Upload, ArrowRight, Loader2 } from 'lucide-react';
import { MondrianButton } from './ui/MondrianButton';
import { MondrianPanel } from './ui/MondrianPanel';
import { EvolutionStages } from './EvolutionStages';
import { MondrianGrid } from './MondrianGrid';
interface AbstractionEngineProps {
  onComplete: (gridData: any) => void;
}
export function AbstractionEngine({
  onComplete
}: AbstractionEngineProps) {
  const [image, setImage] = useState<string | null>(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [stage, setStage] = useState<0 | 1 | 2 | 3 | 4>(0);
  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = e => {
        setImage(e.target?.result as string);
        setStage(1);
      };
      reader.readAsDataURL(file);
    }
  };
  const startEvolution = () => {
    if (!image) return;
    setIsProcessing(true);
    // Simulate the AI processing stages
    let current = 1;
    const interval = setInterval(() => {
      current++;
      setStage(current as any);
      if (current === 4) {
        clearInterval(interval);
        setIsProcessing(false);
        onComplete({
          generated: true,
          timestamp: Date.now()
        });
      }
    }, 1500); // 1.5s per stage
  };
  return <div className="space-y-8" data-id="element-3">
      <div className="text-center space-y-2" data-id="element-4">
        <h2 className="text-2xl font-bold uppercase" data-id="element-5">工具一：抽象进化引擎</h2>
        <p className="text-gray-600" data-id="element-6">上传照片，见证从具象到本质的演变</p>
      </div>

      {/* Upload Area */}
      {!image && <MondrianPanel className="h-64 flex flex-col items-center justify-center border-dashed cursor-pointer hover:bg-gray-50 transition-colors relative" data-id="element-7">
          <input type="file" accept="image/*" onChange={handleUpload} className="absolute inset-0 opacity-0 cursor-pointer" data-id="element-8" />
          <div className="bg-mondrian-blue p-4 mb-4" data-id="element-9">
            <Upload className="w-8 h-8 text-white" data-id="element-10" />
          </div>
          <p className="font-bold text-lg" data-id="element-11">点击上传图片</p>
          <p className="text-sm text-gray-500 mt-2" data-id="element-12">支持 JPG, PNG</p>
        </MondrianPanel>}

      {/* Evolution Display */}
      {image && <div className="space-y-8" data-id="element-13">
          <EvolutionStages currentStage={stage} originalImage={image} data-id="element-14" />

          {stage === 1 && <div className="flex justify-center" data-id="element-15">
              <MondrianButton variant="yellow" onClick={startEvolution} disabled={isProcessing} className="flex items-center gap-2 text-xl px-8 py-4" data-id="element-16">
                {isProcessing ? <Loader2 className="animate-spin" data-id="element-17" /> : '去伪存真'}
                {!isProcessing && <ArrowRight data-id="element-18" />}
              </MondrianButton>
            </div>}

          {stage === 4 && <div className="text-center animate-fade-in" data-id="element-19">
              <p className="text-xl font-bold mb-4" data-id="element-20">抽象化完成</p>
              <div className="h-64 w-full md:w-2/3 mx-auto border-8 border-mondrian-black" data-id="element-21">
                <MondrianGrid density="high" animated data-id="element-22" />
              </div>
            </div>}
        </div>}
    </div>;
}